<template>
    <page
        id="engagement-report-page"
        :title="page_title"
        :status="page_status"
        :waiting="waiting"
        @statused="statused"
    >
        <template v-slot:title>
            <div class="uk-container uk-container-center uk-margin-top">
                <h1>{{ page_title }}</h1>
            </div>
        </template>
        <prospective-projects-data-table
            id="engagement-report"
            :user-id="pic_id"
            context="engagement"
        />
    </page>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"

import is_page from "../../mixins/IsPage"

import ProspectiveProjectsDataTable from "../../ui/ProspectiveProjectsDataTable"

export default {
    mixins: [is_page],
    components: {
        ProspectiveProjectsDataTable
    },
    computed: {
        ...mapGetters(["entity_record"]),
        pic_id () {
            return parseInt(this.$route.params.id)
        },
        page_title () {
            const user = this.entity_record("user", this.pic_id)
            return user ? `Engagement Report for ${user.initials}` : "Engagement Report"
        }
    }
}
</script>
